import axios from "axios";
import { openNotification } from "../components/shared/errorNotification/errorNotification";
import { store } from "../redux/store";
import { FinishLoading, TotalRequest } from "../redux/features/loader";
import { Status } from "../shared/constant";
import { setupCache } from "axios-cache-interceptor";
import { Config } from "config";

const axiosInstance = axios.create({
  baseURL: Config.apiBaseUrl,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

const Api = setupCache(axiosInstance, {
  methods: []
});

Api.interceptors.request.use(
  async config => {
    await store?.dispatch(TotalRequest());
    config.headers["access-key"] = Config.apiAccessKey;
    return config;
  },
  async error => {
    await store?.dispatch(FinishLoading());
    return Promise.reject(error);
  }
);

Api.interceptors.response.use(
  async response => {
    await store?.dispatch(FinishLoading());
    const { meta } = response.data;
    if (meta?.statusCode == Status.CREATED || meta?.statusCode == Status.SUCCESS) {
      response.data.success = true;
    }
    return response;
  },
  async error => {
    const res = error?.response;
    const AUTH_DISABLED_NOTIFICATION_ENDPOINTS = ["users/me", "users/verify-hash"];
    await store?.dispatch(FinishLoading());
    let message = res?.data?.message || res?.data?.meta?.message || res?.meta?.error;
    if (Array.isArray(res?.data?.meta?.message)) {
      message = res.data.meta?.message[0];
    }
    if (
      !(window.location.href.includes("auth") && AUTH_DISABLED_NOTIFICATION_ENDPOINTS.some(endpoint => res.request.responseURL.includes(endpoint)))
    ) {
      openNotification("error", message);
    }
    res.data = { ...res.data, success: false };
    if (res?.status === 401 && !window.location.href.includes("auth")) {
      window.location.href = "/auth";
      return res;
    } else if (res?.status === 410) {
      window.location.href = "/dashboard";
      return res;
    }
    return res;
  }
);

export default Api;
